import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import services from './data/services';

const routes = [
  { path: '/', element: <HomePage /> },
  { path: '/service', element: <ServicesPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/contact', element: <ContactPage /> },
  ...services.map((service) => ({
    path: `/service/${service.slug}`,
    element: <ServiceDetailPage service={service} />,
  })),
];

export default routes;
